export const ESTAFF_INDEX_REBUILDING_MESSAGE = 'Индекс данных в процессе';
export const ESTAFF_SEARCH_TIMEOUT_MESSAGE = 'Поиск занял слишком много времени. Уточните фильтры и попробуйте снова';
export const ESTAFF_SEARCH_UNAVAILABLE_MESSAGE = 'Поиск временно недоступен. Попробуйте позже';

const extractErrorText = (error) => {
  const data = error?.response?.data;
  const apiError = data?.error;

  if (typeof apiError === 'string') {
    return apiError;
  }

  return (
    apiError?.message ||
    data?.message ||
    data?.detail ||
    error?.message ||
    ''
  );
};

const isEStaffApplicantsSearch = (error) => {
  const config = error?.config || error?.response?.config || {};
  const url = String(config.url || error?.request?.responseURL || '');
  const params = config.params || {};
  const source = String(params.source || '').toLowerCase();

  return url.includes('/applicants') && source === 'estaff';
};

export const getResultsLoadErrorMessage = (error) => {
  const message = extractErrorText(error);
  const status = error?.response?.status;
  const lowerMessage = String(message).toLowerCase();
  const isGeneric503 = !message || lowerMessage === 'request failed with status code 503';

  // Таймаут запроса (длинный mirror search) — проверяется ПЕРВЫМ.
  // Раньше rebuild-ветка была первой и ловила generic 503 от /applicants
  // (когда detail отсутствовал или приходил уже после parse) → пользователь
  // видел ложное «Индекс данных в процессе» при реальных таймаутах.
  // Теперь timeout-сигнатуры распознаются явно ДО rebuild-эвристики.
  if (
    status === 503 &&
    (
      lowerMessage.includes('page query failed') ||
      lowerMessage.includes('timed out') ||
      lowerMessage.includes('statement timeout')
    )
  ) {
    return ESTAFF_SEARCH_TIMEOUT_MESSAGE;
  }

  // Rebuild-эвристика: явные сообщения от hr-proxy ИЛИ generic 503 от
  // E-Staff /applicants (из 672). Generic 503 интерпретируется как
  // «индекс перестраивается» только если выше не сработал timeout.
  if (
    status === 503 &&
    (
      (isEStaffApplicantsSearch(error) && isGeneric503) ||
      lowerMessage.includes('mirror search temporarily unavailable') ||
      lowerMessage.includes('mirror search index') ||
      lowerMessage.includes('search index is rebuilding')
    )
  ) {
    return ESTAFF_INDEX_REBUILDING_MESSAGE;
  }

  // Общий fallback для generic 503 без специфичного контекста: HR-Proxy недоступен.
  if (status === 503 && isGeneric503) {
    return ESTAFF_SEARCH_UNAVAILABLE_MESSAGE;
  }

  return message || 'Не удалось загрузить данные';
};
